import { PropsWithChildren, forwardRef } from 'react'
import Styles from './TabPanel.module.scss'
import { AriaLabelingProps } from '@react-types/shared'
import { Header } from './Header'

const Root = (props: PropsWithChildren<AriaLabelingProps>) => {
  return <div role="tabpanel" className={Styles.tabPanel} {...props} />
}

const Body = forwardRef<HTMLDivElement, PropsWithChildren>((props, fRef) => {
  return <div ref={fRef} className={Styles.body} {...props} />
})

export const TabPanel = {
  Root,
  Header,
  Body,
}
